import { Grid } from '@material-ui/core';
import { isEmpty } from 'lodash-es';
import moment from 'moment';
import React from 'react';

import { DateGroup } from '~/src/dash/api/console-api';
import { LoadingState, LoadingStateLoading } from '~/src/dash/utils/loading-states';
import { IMeasurementDataItem } from '~/src/dash/views/common/ias-data-consts';
import {
  IIASDashboardDisplayedCardKeyAndColor,
  IIASDashboardMetricInfo,
  IIASDashboardQueryParams,
  IIASDashboardSectionSecondaryChartInfo,
} from '~/src/dash/views/ias-publisher/IASDashboard/common/types';
import { IASDashboardChart } from '~/src/dash/views/ias-publisher/IASDashboard/IASDashboardCharts/IASDashboardChart';
import { IASDashboardSecondaryChart } from '~/src/dash/views/ias-publisher/IASDashboard/IASDashboardCharts/IASDashboardSecondaryChart';

interface IIASDashboardChartsProps {
  classes: { [key: string]: string };
  colors: Record<string, string>;
  loadState: LoadingState;
  chartLoadState: number;
  compChartLoadState: number;
  data: IMeasurementDataItem[];
  calStartDate: moment.Moment;
  compStartDate: moment.Moment;
  calEndDate: moment.Moment;
  compEndDate: moment.Moment;
  handleDensityRangeChange: (densityRangeAgg: DateGroup) => void;
  densityRangeAgg: DateGroup;
  isComparedToEnabled: boolean;
  metrics: Record<string, IIASDashboardMetricInfo>;
  activeMetrics: Record<string, boolean>;
  displayedCardsKeysAndColors: IIASDashboardDisplayedCardKeyAndColor[];
  areCardsSelectable: boolean | undefined;
  queryParams?: IIASDashboardQueryParams;
  secondaryCharts?: IIASDashboardSectionSecondaryChartInfo[];
}

export const IASDashboardCharts = ({
  classes,
  colors,
  loadState,
  chartLoadState,
  compChartLoadState,
  data,
  handleDensityRangeChange,
  calStartDate,
  calEndDate,
  compStartDate,
  compEndDate,
  densityRangeAgg,
  isComparedToEnabled,
  metrics,
  activeMetrics,
  displayedCardsKeysAndColors,
  areCardsSelectable,
  queryParams = {} as IIASDashboardQueryParams,
  secondaryCharts = [] as IIASDashboardSectionSecondaryChartInfo[],
}: IIASDashboardChartsProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item style={{ width: '100%' }}>
        <IASDashboardChart
          classes={classes}
          data={data}
          handleDensityRangeChange={handleDensityRangeChange}
          calStartDate={calStartDate}
          calEndDate={calEndDate}
          compStartDate={compStartDate}
          compEndDate={compEndDate}
          loadState={loadState}
          chartLoadState={chartLoadState}
          compChartLoadState={compChartLoadState}
          densityRangeAgg={densityRangeAgg}
          isComparedToEnabled={isComparedToEnabled}
          metrics={metrics}
          activeMetrics={activeMetrics}
          displayedCardsKeysAndColors={displayedCardsKeysAndColors}
          areCardsSelectable={areCardsSelectable}
        />
      </Grid>
      {secondaryCharts.length > 0 &&
        !isEmpty(queryParams) &&
        loadState !== LoadingStateLoading &&
        secondaryCharts.map((chart) => {
          return (
            <Grid item xs={6} style={{ width: '100%' }}>
              <IASDashboardSecondaryChart
                classes={classes}
                colors={colors}
                queryParams={queryParams}
                chartInfo={chart}
                isComparedToEnabled={isComparedToEnabled}
              />
            </Grid>
          );
        })}
    </Grid>
  );
};
